import { MouseEvent, useState } from 'react'
import { Printer } from 'react-feather'
import { MaterialItemDTO } from '../DTO/MaterialItemDTO'
import { findPrintFormat, groupByPrintSettings } from '../DTO/PrintFormats'
import { printPdfWithQz, qzErrorMessage, qzJobFromPrintGroup } from '../services/QzPrint'
import { MakePrintLink } from './MakePrintLink'
import './AssetQzPrintButton.scss'

export default function AssetQzPrintButton(props: {
  item: MaterialItemDTO,
  compact?: boolean,
}) {
  const [busy, setBusy] = useState(false)
  const [count, setCount] = useState('1')
  const item = props.item
  if (item.id < 0) { return null }
  if (props.compact && !findPrintFormat(item.getPropV1('data', 'printFormat'))) { return null }

  const run = async (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    if (busy) { return }
    const group = groupByPrintSettings([item])[0]
    if (!group) {
      window.alert('Kein Druckformat hinterlegt.')
      return
    }
    const copies = parseInt(count, 10)
    if (!props.compact && (!Number.isFinite(copies) || copies < 1)) {
      window.alert('Bitte eine Anzahl ab 1 angeben.')
      return
    }
    const url = MakePrintLink({
      flips: [item],
      size: group.sizeToken,
      copies: props.compact ? 1 : copies,
    })
    if (!url) {
      window.alert('Keine Datei zum Drucken.')
      return
    }
    setBusy(true)
    try {
      await printPdfWithQz(qzJobFromPrintGroup(group, url))
    } catch (error) {
      window.alert(qzErrorMessage(error))
    } finally {
      setBusy(false)
    }
  }

  const title = busy ? 'Druck wird gesendet…' : 'Mit QZ Tray drucken'
  if (props.compact) {
    const hasFile = !!item.getCurrentFile()?.file
    return <button
      type='button'
      className='asset-qz-print-icon editItem pointer'
      title={hasFile ? title : 'Keine Datei zum Drucken'}
      disabled={!hasFile || busy}
      onMouseDown={(event) => event.stopPropagation()}
      onClick={run}
    >
      <Printer size='20px' />
    </button>
  }
  return <div className='asset-qz-print-row'>
    <label className='asset-qz-print-count'>
      Anzahl
      <input
        type='number'
        min={1}
        step={1}
        value={count}
        disabled={busy}
        title='Anzahl der Ausdrucke'
        onChange={(event) => setCount(event.target.value)}
      />
    </label>
    <button
      type='button'
      className='neutralButton asset-qz-print'
      title={title}
      disabled={busy}
      onClick={run}
    >
      <Printer size='16px' />
      <span className='name'>{busy ? 'Druckt…' : 'Drucken'}</span>
    </button>
  </div>
}
